import styled from '@emotion/styled';

export const ReviewScrollArea = styled.div(({ theme }) => ({
  maxHeight: 820,
  paddingBottom: 5,
  overflowY: 'auto',
  height: 'calc(100svh - 100px)',
  '&::-webkit-scrollbar': {
    width: 2,
  },
  '&:hover': {
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: 10,
    },
  },
}));
